/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { AdminGetOrgMembersOptions, AdminGetOrgMembersStatus200, AdminGetOrgMembersStatus422 } from '../models/AdminGetOrgMembers'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { adminGetOrgMembers } from '../clients/axios/adminGetOrgMembers'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const adminGetOrgMembersQueryKey = ({ path, query }: Omit<AdminGetOrgMembersOptions, 'headers'>) => [{ url: '/admin/org/:org_id/members', params: path }, ...(query ? [query] : [])] as const

type AdminGetOrgMembersQueryKey = ReturnType<typeof adminGetOrgMembersQueryKey>

export function adminGetOrgMembersQueryOptions({ path, query }: AdminGetOrgMembersOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = adminGetOrgMembersQueryKey({ path, query })
  return queryOptions<AdminGetOrgMembersStatus200, ResponseErrorConfig<AdminGetOrgMembersStatus422>, AdminGetOrgMembersStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await adminGetOrgMembers({ ...config, path, query, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @description Get all members of the org.
 * @summary Get Org Members
 * {@link /admin/org/:org_id/members}
 */
export function useAdminGetOrgMembers<TData = AdminGetOrgMembersStatus200, TQueryData = AdminGetOrgMembersStatus200, TQueryKey extends QueryKey = AdminGetOrgMembersQueryKey>({ path, query }: { path: AdminGetOrgMembersOptions['path'] | (() => AdminGetOrgMembersOptions['path']); query?: AdminGetOrgMembersOptions['query'] | (() => AdminGetOrgMembersOptions['query']) }, options: {
  query?: Partial<QueryObserverOptions<AdminGetOrgMembersStatus200, ResponseErrorConfig<AdminGetOrgMembersStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path, query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? adminGetOrgMembersQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...adminGetOrgMembersQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AdminGetOrgMembersStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
